import { useState } from "react";
import API from "../../services/api";
import "./AddAddressModal.css";

function AddAddressModal({

  closeModal,

  refreshAddresses

}) {

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({

    fullName: "",

    phone: "",

    houseNo: "",

    apartment: "",

    street: "",

    landmark: "",

    area: "",

    city: "",

    district: "",

    state: "",

    country: "India",

    pincode: "",

    latitude: null,

    longitude: null,

    addressType: "Home",

    deliveryInstructions: ""

  });

  /* ==========================================
        Handle Input Change
  ========================================== */

  const handleChange = (e) => {

    const { name, value } = e.target;

    setForm((prev) => ({

      ...prev,

      [name]: value

    }));

  };

  /* ==========================================
        Address Type
  ========================================== */

  const selectAddressType = (type) => {

    setForm((prev) => ({

      ...prev,

      addressType: type

    }));

  };

  /* ==========================================
        Detect Current Location
  ========================================== */

  const getCurrentLocation = () => {

    if (!navigator.geolocation) {

      alert("Geolocation is not supported.");

      return;

    }

    setLoading(true);

    navigator.geolocation.getCurrentPosition(

      async (position) => {

        try {

          const latitude = position.coords.latitude;

          const longitude = position.coords.longitude;

          const { data } = await API.post(

            "/address/reverse-geocode",

            {

              latitude,

              longitude

            }

          );

          setForm((prev) => ({

            ...prev,

            latitude,

            longitude,

            street: data.address.street || "",

            landmark: data.address.landmark || "",

            area: data.address.area || "",

            city: data.address.city || "",

            district: data.address.district || "",

            state: data.address.state || "",

            country: data.address.country || "India",

            pincode: data.address.pincode || ""

          }));

        }

        catch (error) {

          console.error(error);

          alert("Unable to detect address.");

        }

        finally {

          setLoading(false);

        }

      },

      (error) => {

        console.error(error);

        setLoading(false);

        alert("Unable to fetch your location.");

      },

      {

        enableHighAccuracy: true,

        timeout: 10000,

        maximumAge: 0

      }

    );

  };

  /* ==========================================
        Save Address
  ========================================== */

  const handleSave = async () => {

    if (

      !form.fullName ||

      !form.phone ||

      !form.houseNo ||

      !form.street ||

      !form.city ||

      !form.state ||

      !form.pincode

    ) {

      alert("Please fill all required fields.");

      return;

    }

    try {

      setLoading(true);

      await API.post(

        "/address",

        form

      );

      alert("✅ Address Added Successfully");

      await refreshAddresses();

      closeModal();

    }

    catch (error) {

      console.error(error);

      alert(

        error.response?.data?.message ||

        "Failed to Add Address"

      );

    }

    finally {

      setLoading(false);

    }

  };

  return (

    <div className="modal-overlay">

      <div className="address-modal">
                {/* ==========================================
                Header
        ========================================== */}

        <div className="modal-header">

          <h2>

            📍 Add Delivery Address

          </h2>

          <button

            type="button"

            className="close-modal"

            onClick={closeModal}

          >

            ✕

          </button>

        </div>

        {/* ==========================================
                Scrollable Form Area
        ========================================== */}

        <div className="address-form">

          {/* ==========================================
                  Current Location Card
          ========================================== */}

          <div className="current-location-card">

            <div>

              <h3>

                📍 Detect Current Location

              </h3>

              <p>

                Automatically fill your address using GPS.

              </p>

            </div>

            <button

              type="button"

              className="location-btn"

              onClick={getCurrentLocation}

              disabled={loading}

            >

              {

                loading

                  ? (

                    <>

                      <span className="spinner"></span>

                      Detecting...

                    </>

                  )

                  : (

                    <>📍 Use Location</>

                  )

              }

            </button>

          </div>

          {

            form.latitude && (

              <div className="location-success">

                ✅ Address detected successfully.

                Please verify your house number before saving.

              </div>

            )

          }

          {/* ==========================================
                  Full Name + Phone
          ========================================== */}

          <div className="double-input">

            <div className="input-group">

              <label>Full Name *</label>

              <input

                type="text"

                name="fullName"

                value={form.fullName}

                onChange={handleChange}

                placeholder="Enter full name"

              />

            </div>

            <div className="input-group">

              <label>Phone Number *</label>

              <input

                type="tel"

                name="phone"

                value={form.phone}

                onChange={handleChange}

                placeholder="Enter phone number"

              />

            </div>

          </div>

          {/* ==========================================
                  House + Apartment
          ========================================== */}

          <div className="double-input">

            <div className="input-group">

              <label>House / Door No *</label>

              <input

                type="text"

                name="houseNo"

                value={form.houseNo}

                onChange={handleChange}

                placeholder="House / Flat No"

              />

            </div>

            <div className="input-group">

              <label>Apartment / Building</label>

              <input

                type="text"

                name="apartment"

                value={form.apartment}

                onChange={handleChange}

                placeholder="Apartment / Building"

              />

            </div>

          </div>

          {/* ==========================================
                  Street + Landmark
          ========================================== */}

          <div className="double-input">

            <div className="input-group">

              <label>Street *</label>

              <input

                type="text"

                name="street"

                value={form.street}

                onChange={handleChange}

                placeholder="Street"

              />

            </div>

            <div className="input-group">

              <label>Landmark</label>

              <input

                type="text"

                name="landmark"

                value={form.landmark}

                onChange={handleChange}

                placeholder="Nearby Landmark"

              />

            </div>

          </div>

          {/* ==========================================
                  Area + Pincode
          ========================================== */}

          <div className="double-input">

            <div className="input-group">

              <label>Area</label>

              <input

                type="text"

                name="area"

                value={form.area}

                onChange={handleChange}

                placeholder="Area"

              />

            </div>

            <div className="input-group">

              <label>Pincode *</label>

              <input

                type="text"

                name="pincode"

                value={form.pincode}

                onChange={handleChange}

                placeholder="Pincode"

              />

            </div>

          </div>

          {/* ==========================================
                  City + District
          ========================================== */}

          <div className="double-input">

            <div className="input-group">

              <label>City *</label>

              <input

                type="text"

                name="city"

                value={form.city}

                onChange={handleChange}

                placeholder="City"

              />

            </div>

            <div className="input-group">

              <label>District</label>

              <input

                type="text"

                name="district"

                value={form.district}

                onChange={handleChange}

                placeholder="District"

              />

            </div>

          </div>

          {/* ==========================================
                  State + Country
          ========================================== */}

          <div className="double-input">

            <div className="input-group">

              <label>State *</label>

              <input

                type="text"

                name="state"

                value={form.state}

                onChange={handleChange}

                placeholder="State"

              />

            </div>

            <div className="input-group">

              <label>Country</label>

              <input

                type="text"

                name="country"

                value={form.country}

                onChange={handleChange}

                placeholder="Country"

              />

            </div>

          </div>

          {/* ==========================================
                  Delivery Instructions
          ========================================== */}

          <div className="input-group">

            <label>

              Delivery Instructions

            </label>

            <textarea

              name="deliveryInstructions"

              value={form.deliveryInstructions}

              onChange={handleChange}

              rows={4}

              placeholder="Call before delivery, leave at the gate, ring the bell..."

            />

          </div>

          {/* ==========================================
                  Address Type
          ========================================== */}

          <div className="save-address-as">

            <label>

              Save Address As

            </label>

            <div className="address-types">

              <button

                type="button"

                className={

                  form.addressType === "Home"

                    ? "type-btn active"

                    : "type-btn"

                }

                onClick={() => selectAddressType("Home")}

              >

                🏠 Home

              </button>

              <button

                type="button"

                className={

                  form.addressType === "Work"

                    ? "type-btn active"

                    : "type-btn"

                }

                onClick={() => selectAddressType("Work")}

              >

                🏢 Work

              </button>

              <button

                type="button"

                className={

                  form.addressType === "Other"

                    ? "type-btn active"

                    : "type-btn"

                }

                onClick={() => selectAddressType("Other")}

              >

                📍 Other

              </button>

            </div>

          </div>
                  {/* ==========================================
                Modal Footer
        ========================================== */}

        </div>

        <div className="modal-buttons">

          <button

            type="button"

            className="cancel-btn"

            onClick={closeModal}

            disabled={loading}

          >

            Cancel

          </button>

          <button

            type="button"

            className="save-btn"

            onClick={handleSave}

            disabled={loading}

          >

            {

              loading

                ? (

                  <>

                    <span className="spinner"></span>

                    Saving...

                  </>

                )

                : (

                  "Save Address"

                )

            }

          </button>

        </div>

      </div>

    </div>

  );

}

export default AddAddressModal;